
import './Preferential_Issue.css';

import useMeta from '../../../hooks/useMeta';


import Footer from "../../../CommonComponent/Footer/footer";
import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";

const Preferential_issue = () => {

    useMeta({
        title: 'Preferential issue | Marvel Blinds',
        description: "Statement of Deviation or Variation Complaince Certificate Reg.163 Outcome of Board Meeting_18_07_2024 Notice of EGM 14_08_2024 Attendence Slip Proxy Form Corrigendum to Notice of EGM Scrutinizer Report Proceedings of EGM 14_08_2024",
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/preferential-issue`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Preferential issue',
            description: "Statement of Deviation or Variation Complaince Certificate Reg.163 Outcome of Board Meeting_18_07_2024 Notice of EGM 14_08_2024 Attendence Slip Proxy Form Corrigendum to Notice of EGM Scrutinizer Report Proceedings of EGM 14_08_2024",
            url: `${process.env.REACT_APP_WEBSITE_URL}/preferential-issue`,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="PI-pg-container">

                <h2 className="PI-pg-title">Preferential Issue</h2>
                <a class="Annual_report" href="/preferential-issue-2024" data-discover="true">2024</a>
                
                <table className="PI-pg-content-table">
                    <tr>
                        <td> <a target='_BLANK' href='/Documnets/compliance_cert_2026.pdf'>Compliance Certificate</a></td>
                    </tr>
                    <tr>
                        <td> <a target='_BLANK' href='/Documnets/valuation_rpt_2026.pdf'>Valuation Report</a></td>
                    </tr>
                    <tr>
                        <td> <a target='_BLANK' href='/Documnets/proxy_form_2026.pdf'>Proxy Form</a></td>
                    </tr>
                    <tr>
                        <td> <a target='_BLANK' href='/Documnets/att_slips_2026.pdf'>Attendence Slip</a></td>
                    </tr>
                    <tr>
                        <td> <a target='_BLANK' href='/Documnets/EGM_NOTICE_MDL.pdf'>Notice of EGM</a></td>
                    </tr>
                    
                    <tr>

                    </tr>

                </table>
            </div>
            <Footer />
        </>
    );
}

export default Preferential_issue;